import React from 'react';
import styled from 'styled-components';
import { minBp } from 'lib/theme';

export const DisclaimerContainer = styled.div`
  ${({ theme, financeOptionsLeftPosition }) => `
  background: #fff;
  border-radius: 4px;
  width: calc(100% - 30px);
  position: absolute;
  bottom: ${theme.heights.tray.mobile + 12}px;
  left: 15px;

  @media ${minBp('tablet')} {
    width: 290px;
    bottom: ${theme.heights.tray.tablet + 12}px;
    left: ${financeOptionsLeftPosition}px;
  }

  @media ${minBp('tabletLarge')} {
    bottom: ${theme.heights.tray.desktop + 12}px;
  }
`}
`;

export const DisclaimerTriangle = styled.div`
  ${({ infoButtonLeftPosition }) => `
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #fff;
  position: absolute;
  left: ${infoButtonLeftPosition - 4}px;
  top: -13px;

  @media ${minBp('tabletLarge')} { 
    left: ${infoButtonLeftPosition}px;
  }
`}
`;

export const DisclaimerContent = styled.div`
  position: relative;
  padding: 19px 20px 9px;
`;

export const DisclaimerText = styled.span`
  display: block;
  margin-right: 16px;
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  font-size: 10px;
  color: #585a5f;

  @media ${minBp('tabletLarge')} {
    font-size: 12px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
`;
